import { render, staticRenderFns } from "./RoleUpdate.vue?vue&type=template&id=4cd9476c&scoped=true&"
import script from "./RoleUpdate.vue?vue&type=script&lang=js&"
export * from "./RoleUpdate.vue?vue&type=script&lang=js&"
import style0 from "./RoleUpdate.vue?vue&type=style&index=0&id=4cd9476c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd9476c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
